import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

// UI-12, PF-06: draws chart data computed on the server.
export default class extends Controller {
  static values = { data: Object }

  connect() {
    const { type, labels, datasets } = this.dataValue
    this.chart = new Chart(this.element.querySelector("canvas"), {
      type,
      data: { labels, datasets },
      options: { locale: "id-ID", responsive: true, maintainAspectRatio: false, animation: false }
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
